import Hero from "./components/Hero";
import TrustBadges from "./components/TrustBadges";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonTable from "./components/ComparisonTable";
import ContentSection from "./components/ContentSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBadges />
      <CategoryGrid />
      <ComparisonTable />
      <ContentSection />
      <FAQSection />
      <Footer />
    </>
  );
}